import { render } from "./addModuleTemplate.vue?vue&type=template&id=26e4945a"
import script from "./addModuleTemplate.vue?vue&type=script&lang=js"
export * from "./addModuleTemplate.vue?vue&type=script&lang=js"

import "./addModuleTemplate.vue?vue&type=style&index=0&id=26e4945a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__